(() => {
  const instances = new WeakMap();

  const initHeader = (scope = document) => {
    scope.querySelectorAll('[data-header]').forEach((header) => {
      if (instances.has(header)) return;
      const toggle = header.querySelector('[data-header-toggle]');
      const navigation = header.querySelector('[data-header-nav]');
      if (!(toggle instanceof HTMLButtonElement) || !(navigation instanceof HTMLElement)) return;

      const close = () => {
        navigation.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      };

      const onToggle = () => {
        const open = navigation.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      };

      const onKeydown = (event) => {
        if (event.key === 'Escape') {
          close();
          toggle.focus();
        }
      };

      toggle.addEventListener('click', onToggle);
      header.addEventListener('keydown', onKeydown);
      navigation.addEventListener('click', close);

      instances.set(header, () => {
        toggle.removeEventListener('click', onToggle);
        header.removeEventListener('keydown', onKeydown);
        navigation.removeEventListener('click', close);
      });
    });
  };

  const unloadHeader = (scope) => {
    scope.querySelectorAll('[data-header]').forEach((header) => {
      const cleanup = instances.get(header);
      if (cleanup) cleanup();
      instances.delete(header);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initHeader());
  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadHeader(event.target));
})();
